export function isValueBladeController(bc) {
    return 'value' in bc;
}
